import { useTranslation } from 'react-i18next';

import ThankYouModal from 'packages/kakapo-ui-kit/components/modals/ThankYouModal';

import FeedbackCreateThankYouState from 'packages/kakapo-ui-kit/assets/illustrations/FeedbackCreateThankYouState.svg?url';

export default function FeedbackThankYou(props: { external?: boolean }) {
	const { t } = useTranslation();

	return (
		<ThankYouModal
			title={t('common.feedback.feedbackResponseSent')}
			imageSrc={FeedbackCreateThankYouState}
			{...(props.external
				? {
						to: 'https://treams.nl',
						buttonTitle: t('common.feedback.viewTreamsWebsite'),
				  }
				: {
						to: '/',
						buttonTitle: t('feedback.respond.success.backButton'),
				  })}
		/>
	);
}
